<template>
  <v-date-picker class="my-0 inline-block h-full" v-model="date" :masks="{input: 'YYYY-MM-DD'}">
    <template v-slot="{ inputValue, togglePopover }">
      <mdb-form-inline>
        <mdb-input :label="label" class="my-1"  :value="inputValue"  disabled style="width:100px"/>
        <mdb-btn icon="calendar-day" class="p-0 m-0 mr-1" @click.native="togglePopover"/>
        <mdb-btn icon="times" color="danger" class="m-0 p-0" @click.native="onClear"/>
      </mdb-form-inline>
    </template>
  </v-date-picker>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'DatePicker',
  props: ['value', 'label'],
  data: function () {
    return {
      date: this.value
    }
  },
  watch: {
    date () {
      this.$emit('input', this.date)
    },
    value () {
      this.date = this.value
    }
  },
  methods: {
    onClear () {
      if (confirm('날짜를 지울까요?')) this.date = undefined
    }
  }
}
</script>
